import React from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";

import GatewayRequestDebugPanel from "../Missing/GatewayRequestDebugPanel";
import MissingRetailerControl from "../Missing/MissingRetailerControl";

const LocationMissingBulkBar = ({
  selectedCount,
  retailerId,
  retailerName,
  onRetailerIdChange,
  onRetailerNameChange,
  province,
  onProvinceChange,
  provinceOptions = [],
  bulkUpdateRequestPreview,
  onApply,
  applying,
  disabled,
}) => {
  if (!selectedCount) {
    return null;
  }

  const canApply =
    !disabled &&
    !applying &&
    selectedCount > 0 &&
    (retailerId || province);

  return (
    <Box
      sx={{
        mb: 2,
        p: 1.5,
        border: "1px solid #ddd",
        borderRadius: 1,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Bulk update {selectedCount} selected record{selectedCount === 1 ? "" : "s"}
      </Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ md: "flex-start" }}>
        <Box sx={{ minWidth: 280, flex: 1 }}>
          <MissingRetailerControl
            retailerId={retailerId}
            retailerName={retailerName}
            onRetailerIdChange={onRetailerIdChange}
            onRetailerNameChange={onRetailerNameChange}
          />
        </Box>

        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="location-missing-bulk-province-label">Province</InputLabel>
          <Select
            labelId="location-missing-bulk-province-label"
            label="Province"
            value={province || ""}
            onChange={(event) => {
              onProvinceChange(event.target.value);
            }}
          >
            <MenuItem value="">
              <em>Leave unchanged</em>
            </MenuItem>
            {provinceOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="secondary"
          disabled={!canApply}
          onClick={onApply}
          sx={{ alignSelf: { md: "center" }, mt: { xs: 0, md: 0.5 } }}
        >
          {applying ? "Applying..." : "Apply to selected"}
        </Button>
      </Stack>
      <GatewayRequestDebugPanel
        title="Beef AI debug request preview (Location / Missing bulk update)"
        request={bulkUpdateRequestPreview}
      />
    </Box>
  );
};

export default LocationMissingBulkBar;
